import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import RootLayout from "./pages/Root";
import DashboardPage from "./pages/dashboard/Dashboard";
import DocumentationPage from "./pages/documentation/Documentation";
import LoginPage from "./pages/login/Login";
import { AuthProvider } from "./contexts/AuthContext";
import RequireAuth from "./route-guards/RequireAuth";
import Team from "./pages/team/Team";
import { Callback } from "./pages/login/Callback";
import APITestingPage from "./pages/api-testing/APITestingPage";

import Unauthorized from "./pages/unauthorized/Unauthorized";
import Profile from "./pages/profile/Profile";
import Logout from "./pages/login/Logout";
import LoggedOut from "./pages/login/LoggedOut";
import CrossTabLogoutSync from "./contexts/CrossTabLogoutSync";
import Questionnaire from "./components/cert-tabs/Questionnaire";
import WelcomePage from "./pages/welcome/WelcomePage";
import React from "react";
import { CLIENT_ACCOUNT_DETAILS_FORM } from "./constants";

function App() {
    return (
        <AuthProvider>
            <CrossTabLogoutSync />
            <Router>
                <Routes>
                    <Route path="/auth" element={<LoginPage />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/logged-out" element={<LoggedOut />} />
                    <Route path="/auth/callback" element={<Callback />} />

                    <Route path="/" element={<RootLayout />}>
                        <Route element={<RequireAuth />}>
                            <Route index element={<WelcomePage />} />
                        </Route>
                        <Route element={<RequireAuth page="dashboard" />}>
                            <Route
                                path="dashboard"
                                element={<DashboardPage />}
                            />
                        </Route>
                        <Route element={<RequireAuth page="documentation" />}>
                            <Route
                                path="docs"
                                element={<DocumentationPage />}
                            />
                        </Route>
                        <Route element={<RequireAuth page="documentation" />}>
                            <Route
                                path="api-testing/*"
                                element={<APITestingPage />}
                            />
                        </Route>
                        <Route element={<RequireAuth page="documentation" />}>
                            <Route
                                path="client-details"
                                element={
                                    <Questionnaire
                                        key={`dashboard-questionnaire-${CLIENT_ACCOUNT_DETAILS_FORM}`}
                                        questionnaireType={
                                            CLIENT_ACCOUNT_DETAILS_FORM
                                        }
                                    />
                                }
                            />
                        </Route>
                        <Route element={<RequireAuth page="teamMembers" />}>
                            <Route path="team" element={<Team />} />
                        </Route>
                        <Route element={<RequireAuth />}>
                            <Route path="profile" element={<Profile />} />
                        </Route>
                        <Route
                            path="/unauthorized"
                            element={<Unauthorized />}
                        />
                    </Route>
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
